// Remembers that this device has held a signed-in session, across sign-out
// and page loads (deliberately localStorage, not the session-scoped
// pageCache). The auth page uses it to nudge repeat visitors who land on
// /signup toward /signin before the email form's wrong-mode recovery has to
// kick in. Absence proves nothing (cleared storage, new device), so it only
// ever softens the framing — it never switches modes on its own.
const KEY = 'myl_has_signed_in';

export const markDeviceHasSignedIn = () => {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    /* storage unavailable — the nudge is a nice-to-have */
  }
};

export const deviceHasSignedIn = (): boolean => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};
